import { render, staticRenderFns } from "./AccountAddressesCard.vue?vue&type=template&id=2e0ebc10&"
import script from "./AccountAddressesCard.vue?vue&type=script&lang=js&"
export * from "./AccountAddressesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAlert,VSubheader})
